// @flow
import { combineActions, handleActions } from 'redux-actions';

import { upsertResource, upsertResources } from 'data/qcsSyncResourceReducerHelpers';

import * as actions from './actions';
import { mkSpendingWatchListStore } from './types';

const reducer = handleActions({

  // Called when triggering a CRUD operation on transactions. Sagas are also
  // expected to handle the action by initiating the CRUD operation with QCS.
  //
  [combineActions(
    actions.getSpendingWatchLists,
    actions.createSpendingWatchList,
    actions.updateSpendingWatchList,
    actions.deleteSpendingWatchList
  )]: (state) => state,

  // Called when a CRUD operation is successful on transactions. The success
  // action is triggered by the Sagas.
  [combineActions(
    actions.getSpendingWatchListsSuccess
  )]:
    (state, { payload: data }) => upsertResources(state, data),

  // Called when a CRUD operation is successful on transactions. The success
  // action is triggered by the Sagas.
  [combineActions(
    actions.createSpendingWatchListSuccess,
    actions.updateSpendingWatchListSuccess,
    actions.deleteSpendingWatchListSuccess
  )]:
    (state, { payload: spendingWatchListToUpsert }) => upsertResource(state, spendingWatchListToUpsert),

  // Called when a CRUD operation fails on transactions. The failure action
  // is triggered by Sagas.
  [combineActions(
    actions.getSpendingWatchListsFailure,
    actions.createSpendingWatchListFailure,
    actions.updateSpendingWatchListFailure,
    actions.deleteSpendingWatchListFailure
  )]:
    (state, { payload: _error }) =>
      // todo: what else should we do with the failure?
      state,

}, mkSpendingWatchListStore());

export const REDUCER_KEY = 'spendingWatchListStore';
export default reducer;
